import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


// START : New added : for DnD
import ReactDOM from 'react-dom';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
